import React, { useState } from "react";

import { StyledRow } from "App/global-style";
import CollapsibleContainer from "Components/CollapsibleContainer";
import { insuranceNameToProductBackendName } from "Components/Features/CheckPrice/Products/utils";
import { InsuranceTermsPdfButtons } from "Components/InsuranceTermsPdfButtons";
import { IpidPdfButton } from "Components/IpidPdfButtons/IpidPdfButton";
import { useTexts } from "Components/TextContext";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ManualProduct } from "Store/interfaces/products/checkout/ManualProduct";
import { buttonDetailsTrackId } from "Utils/analytics";
import { manualProductDetailsList } from "../ProductDetailsTable/ProductDetailsLists/RiskProducts/ManualProductDetailsList";
import {
  ProductRowDetail,
  ProductRowDetailValue,
} from "../ProductDetailsTable/ProductDetailsTableRow/styled";
import { ProductDetails } from "../ProductDetailsTable/styled";
import { FooterContainer } from "../styled";
import { ButtonContainer, InsuranceProvider } from "./styled";

interface Props {
  readonly product: ManualProduct;
  readonly showDetails?: boolean;
}

export const ManualCardFooter = ({
  product,
  showDetails: defaultShowDetails = false,
}: Props): React.ReactElement => {
  const [showDetails, toggleDetails] = useState<boolean>(defaultShowDetails);
  const { getText } = useTexts();
  const detailsList = manualProductDetailsList(product);
  const productBackendName = insuranceNameToProductBackendName(
    product.insuranceName,
  );

  const handleToggleDetails = (): void => {
    toggleDetails(!showDetails);
  };

  return (
    <FooterContainer className="insurance-details-card__footer">
      <ButtonContainer>
        <ThemedButton
          variant="text"
          trackId={buttonDetailsTrackId("not-editable")}
          onClick={handleToggleDetails}
          iconRight={showDetails ? "chevron-up" : "chevron-down"}
        >
          {getText("insurancecard.button.details")}
        </ThemedButton>
      </ButtonContainer>

      <CollapsibleContainer isOpen={showDetails}>
        <div className="insurance-details-card__footer-details">
          <ProductDetails>
            {detailsList.map((detail, index) => (
              <StyledRow key={index}>
                <ProductRowDetail>{detail.name}</ProductRowDetail>
                <ProductRowDetailValue>{detail.value}</ProductRowDetailValue>
              </StyledRow>
            ))}
          </ProductDetails>

          <IpidPdfButton
            isOnColoredBackground={true}
            productName={product.insuranceName}
          />
          {productBackendName && (
            <InsuranceTermsPdfButtons
              isOnColoredBackground={true}
              productBackendName={productBackendName}
            />
          )}
          <InsuranceProvider>
            {getText("offer.description.riskinsuranceprovider")}
          </InsuranceProvider>
        </div>
      </CollapsibleContainer>
    </FooterContainer>
  );
};
